import { Component, Prop, Vue } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, ProductFact, TranslationModel } from "../models/product";

@Component
export default class ProductFactList extends Vue {

    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    get variant(): Variant {
        return productStore.variant;
    }

    get productFacts(): ProductFact[] {
        return this.variant.productFacts;
    }
}
